module.exports = __webpack_public_path__ + "static/media/paint.2215a90a.svg";